module.exports = __webpack_public_path__ + "media/logos/paypal-small-logo-db79ec38.svg";